import { SimpleGrid as BaseSimpleGrid } from "@chakra-ui/react";

export default BaseSimpleGrid;
